export default __webpack_public_path__ + "static/media/CardContactar.2d92053c.png";